module.exports = __webpack_public_path__ + "static/img/right-top-row-8.b4097768.webp";